export enum WorkspaceStates {
    HOME = 'workspaces.home',
    WORKSPACE = 'workspaces.workspace',
    OBJECT = 'workspaces.object',
    APP = 'workspaces.app',
}
